window.addEventListener('load', (event) => {
  validateRelatedProducts();
  //validateSelectedOptionChecked(); CLD-23 Deactivate add to cart lock feature
});

function validateRelatedProducts(){
  if(document.getElementById('related-products') != null){
    var listRelatedProducts = document.getElementById('related-products').children;
    for(var x = 0; x < listRelatedProducts.length; x++){
      listRelatedProducts[x].classList.remove('not-show');
      listRelatedProducts[x].children[0].addEventListener('click', (e) => {
        //validateSelectedOptionChecked(); CLD-23 Deactivate add to cart lock feature
        if(e.target.checked){ e.target.parentNode.children[3].children[1].classList.add('show'); }
        else{ e.target.parentNode.children[3].children[1].classList.remove('show'); }
      });
    }
  }
}
function validateSelectedOptionChecked(){
  if(document.getElementById('related-products') != null){
    var listRelatedProducts = document.getElementById('related-products').children;
    for(var y = 0; y < listRelatedProducts.length; y++){
      if(listRelatedProducts[y].children[0].checked){ document.getElementById('paymentButtonRelatedProductRelatedVariants').classList.remove('related-product-disable-show'); y = listRelatedProducts.length; }
      else{ document.getElementById('paymentButtonRelatedProductRelatedVariants').classList.add('related-product-disable-show'); }
    }
  }else{ document.getElementById('paymentButtonRelatedProductRelatedVariants').classList.remove('related-product-disable-show'); }
}
